/* facets.js — Dawn-like, con rehydrate immagini, pin banner (opzionale) e re-init OBS */
(function () {
  'use strict';

  /* ============== debounce (safety) ============== */
  if (typeof window.debounce !== 'function') {
    window.debounce = function (fn, wait = 300) {
      let t; return function (...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
    };
  }

  /* ============== CSS “safety” minimale (niente forzature hover) ============== */
  function ensureCssSafety() {
    if (document.getElementById('facets-ajax-visibility-fix-js')) return;
    const style = document.createElement('style');
    style.id = 'facets-ajax-visibility-fix-js';
    style.textContent = `
#ProductGridContainer .scroll-trigger,
#ProductGridContainer .scroll-trigger--cancel{
  opacity:1!important; visibility:visible!important; transform:none!important;
}
    `;
    document.head.appendChild(style);
  }

  /* =======================================================================
     FACETS — versione Dawn, adattata:
     - preserva q/type/options[prefix] in updateURLHash (per /search)
     - dopo ogni swap: rehydrateImages
     - dispatch 'facets:updated' + section/load/resize/scroll per OBS/tema
     - supporto bottone [data-apply-facets] su mobile
  ======================================================================= */

  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
      this.debouncedOnSubmit = debounce((event) => this.onSubmitHandler(event), 800);

      // Delegation input sul custom element
      this.addEventListener('input', this.debouncedOnSubmit);

      // bottone “Applica” (mobile) opzionale
      this.addEventListener('click', (e) => {
        const btn = e.target.closest?.('[data-apply-facets]');
        if (!btn) return;
        e.preventDefault();
        const form = this.querySelector('#FacetFiltersFormMobile') || this.querySelector('form');
        if (!form) return;
        const params = this.createSearchParams(form);
        form.closest('menu-drawer')?.querySelector('summary')?.click();
        this.onSubmitForm(params, e);
      });

      // ESC locale (come Dawn)
      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', (ev) => {
        const k = (ev.key || ev.code || '').toLowerCase();
        if (k === 'escape') ev.target?.blur?.();
      });
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener('popstate', onHistoryChange);

      // ripinna su resize (SOLO se definito in window)
      window.addEventListener('resize', debounce(() => {
        const root = document.getElementById('ProductGridContainer');
        if (root && typeof window.pinBannerLayout === 'function') {
          window.pinBannerLayout(root);
        }
      }, 150));
    }

    static toggleActiveFacets(disable = true) {
      document.querySelectorAll('.js-facet-remove').forEach((el) => el.classList.toggle('disabled', disable));
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      ensureCssSafety();

      // preserva parametri /search (q, type, options[prefix])
      const current = new URLSearchParams(window.location.search.slice(1));
      const p = new URLSearchParams(searchParams || '');
      ['q', 'type', 'options[prefix]'].forEach(k => { if (!p.get(k) && current.get(k)) p.set(k, current.get(k)); });
      const qs = p.toString();

      FacetFiltersForm.searchParamsPrev = qs;
      const sections = FacetFiltersForm.getSections();

      const countContainer = document.getElementById('ProductCount');
      const countContainerDesktop = document.getElementById('ProductCountDesktop');
      const spinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
      spinners.forEach((s) => s.classList.remove('hidden'));
      const gridEl = document.getElementById('ProductGridContainer');
      gridEl?.querySelector('.collection')?.classList.add('loading');
      if (countContainer) countContainer.classList.add('loading');
      if (countContainerDesktop) countContainerDesktop.classList.add('loading');

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}${qs ? `&${qs}` : ''}`;
        const filterDataUrl = (entry) => entry.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(qs);
    }

    static renderSectionFromFetch(url, event) {
      fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html' },
        cache: 'no-store',
        credentials: 'same-origin'
      })
        .then((r) => r.text())
        .then((html) => {
          FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        })
        .catch((e) => {
          console.error('[Facets] fetch error, fallback reload:', e);
          window.location.assign(url);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.getElementById('ProductGridContainer');
      const current = document.getElementById('ProductGridContainer');
      if (!incoming || !current) return;

      // swap contenuto come Dawn
      current.innerHTML = incoming.innerHTML;

      // annulla eventuali scroll-trigger residui
      current.querySelectorAll('.scroll-trigger').forEach((el) => {
        el.classList.add('scroll-trigger--cancel');
      });

      // eventi per re-inizializzare addon/tema
      const sectionId = document.getElementById('product-grid')?.dataset?.id;
      document.dispatchEvent(new Event('facets:updated'));
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId } }));
      if (window.ObsMini?.mount) window.ObsMini.mount(current);
      window.dispatchEvent(new Event('resize'));
      window.dispatchEvent(new Event('scroll'));
    }

    static renderProductCount(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const countHTML = doc.getElementById('ProductCount')?.innerHTML || '';
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');

      if (container) { container.innerHTML = countHTML; container.classList.remove('loading'); }
      if (containerDesktop) { containerDesktop.innerHTML = countHTML; containerDesktop.classList.remove('loading'); }

      const spinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
      spinners.forEach((s) => s.classList.add('hidden'));
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const fetched = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
      const inDom = document.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');

      // rimuovi facet non più presenti
      Array.from(inDom).forEach((el) => {
        if (!Array.from(fetched).some(({ id }) => el.id === id)) el.remove();
      });

      const matchesId = (el) => {
        const jsFilter = event ? event.target.closest('.js-filter') : undefined;
        return jsFilter ? el.id === jsFilter.id : false;
      };

      const facetsToRender = Array.from(fetched).filter((el) => !matchesId(el));
      const countsToRender = Array.from(fetched).find(matchesId);

      facetsToRender.forEach((elToRender, i) => {
        const current = document.getElementById(elToRender.id);
        if (current) {
          current.innerHTML = elToRender.innerHTML;
        } else {
          if (i > 0) {
            const { className: prevClass, id: prevId } = facetsToRender[i - 1];
            if (elToRender.className === prevClass) {
              document.getElementById(prevId).after(elToRender);
              return;
            }
          }
          if (elToRender.parentElement) {
            document.querySelector(`#${elToRender.parentElement.id} .js-filter`).before(elToRender);
          }
        }
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender && event?.target) {
        const closestID = event.target.closest('.js-filter')?.id;
        if (closestID) {
          FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
          FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestID));
          const newFacet = document.getElementById(closestID);
          const selector = newFacet.classList.contains('mobile-facets__details') ? `.mobile-facets__close-button` : `.facets__summary`;
          const toFocus = newFacet.querySelector(selector);
          const isTextInput = event.target.getAttribute('type') === 'text';
          if (toFocus && !isTextInput) toFocus.focus();
        }
      }
    }

    static renderActiveFacets(html) {
      ['.active-facets-mobile', '.active-facets-desktop'].forEach((sel) => {
        const src = html.querySelector(sel);
        if (!src) return;
        const dst = document.querySelector(sel);
        if (dst) dst.innerHTML = src.innerHTML;
      });
      FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
      ['.mobile-facets__open', '.mobile-facets__count', '.sorting'].forEach((sel) => {
        if (!html.querySelector(sel)) return;
        const dst = document.querySelector(sel);
        if (dst) dst.innerHTML = html.querySelector(sel).innerHTML;
      });

      const drawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
      try { drawer?.bindEvents?.(); } catch (_) { /* no-op */ }
    }

    static renderCounts(source, target) {
      const tSum = target.querySelector('.facets__summary');
      const sSum = source.querySelector('.facets__summary');
      if (sSum && tSum) tSum.outerHTML = sSum.outerHTML;

      const tHead = target.querySelector('.facets__header');
      const sHead = source.querySelector('.facets__header');
      if (sHead && tHead) tHead.outerHTML = sHead.outerHTML;

      const tWrap = target.querySelector('.facets-wrap');
      const sWrap = source.querySelector('.facets-wrap');
      if (sWrap && tWrap) {
        const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
        if (isShowingMore) {
          sWrap.querySelectorAll('.facets__item.hidden').forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
        }
        // FIX #3: preserva il nodo, aggiorna solo il contenuto
        tWrap.innerHTML = sWrap.innerHTML;
      }
    }

    static renderMobileCounts(source, target) {
      const tList = target.querySelector('.mobile-facets__list');
      const sList = source.querySelector('.mobile-facets__list');
      if (sList && tList) {
        // FIX #3: preserva il nodo, aggiorna solo il contenuto
        tList.innerHTML = sList.innerHTML;
      }
    }

    static updateURLHash(searchParams) {
      // preserva anche q/type/options[prefix]
      const current = new URLSearchParams(window.location.search.slice(1));
      const p = new URLSearchParams(searchParams || '');
      ['q', 'type', 'options[prefix]'].forEach(k => { if (!p.get(k) && current.get(k)) p.set(k, current.get(k)); });
      const qs = p.toString();
      history.pushState({ searchParams: qs }, '', `${window.location.pathname}${qs ? '?' + qs : ''}`);
    }

    static getSections() {
      return [{ section: document.getElementById('product-grid').dataset.id }];
    }

    createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
      FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');

      // checkbox mobile
      if (event?.target?.classList?.contains('mobile-facets__checkbox')) {
        const params = this.createSearchParams(event.target.closest('form'));
        this.onSubmitForm(params, event);
        return;
      }

      const forms = [];
      const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url = event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
      FacetFiltersForm.renderPage(url);
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();

  /* ====== PriceRange (Dawn) ====== */
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input').forEach((el) => {
        el.addEventListener('change', this.onRangeChange.bind(this));
        el.addEventListener('keydown', this.onKeyDown.bind(this));
      });
      this.setMinAndMaxValues();
    }
    onRangeChange(event) { this.adjustToValidValues(event.currentTarget); this.setMinAndMaxValues(); }
    onKeyDown(event) {
      if (event.metaKey) return;
      const pat = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
      if (!event.key.match(pat)) event.preventDefault();
    }
    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
      if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
      if (minInput.value === '') maxInput.setAttribute('data-min', 0);
      if (maxInput.value === '') minInput.setAttribute('data-max', minInput.getAttribute('data-max'));
    }
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute('data-min'));
      const max = Number(input.getAttribute('data-max'));
      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }
  if (!customElements.get('price-range')) customElements.define('price-range', PriceRange);

  /* ====== FacetRemove (Dawn) ====== */
  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const a = this.querySelector('a'); if (!a) return;
      a.setAttribute('role', 'button');
      a.addEventListener('click', this.closeFilter.bind(this));
      a.addEventListener('keyup', (event) => {
        event.preventDefault();
        if ((event.code || '').toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
    closeFilter(event) {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }
  if (!customElements.get('facet-remove')) customElements.define('facet-remove', FacetRemove);

  /* ====== init ====== */
  ensureCssSafety();

  window.addEventListener('load', () => {
    const root = document.getElementById('ProductGridContainer');
    if (root) {
      document.dispatchEvent(new Event('facets:updated'));
      if (window.ObsMini?.mount) window.ObsMini.mount(root);
    }
  });
})();
